// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateIssueStateMutationVariables = Types.Exact<{
  issueId: Types.Scalars["ID"]["input"];
  newState: Types.Scalars["String"]["input"];
}>;

export type UpdateIssueStateMutation = {
  __typename?: "Mutation";
  updateIssueState?: {
    __typename?: "Issue";
    id: string;
    state: string;
    activity: Array<{
      __typename?: "IssueActivity";
      id: string;
      occurredAt: number;
      kind: Types.ActivityKind;
      description?: string | null;
      severity?: string | null;
      user?: {
        __typename?: "User";
        id: string;
        avatarUrl?: string | null;
        fullname?: string | null;
      } | null;
    }>;
  } | null;
};

export const UpdateIssueStateDocument = gql`
  mutation UpdateIssueState($issueId: ID!, $newState: String!) {
    updateIssueState(issueId: $issueId, newState: $newState) {
      id
      state
      activity {
        id
        occurredAt
        kind
        description
        severity
        user {
          id
          avatarUrl
          fullname
        }
      }
    }
  }
`;
export type UpdateIssueStateMutationFn = Apollo.MutationFunction<
  UpdateIssueStateMutation,
  UpdateIssueStateMutationVariables
>;

/**
 * __useUpdateIssueStateMutation__
 *
 * To run a mutation, you first call `useUpdateIssueStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssueStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssueStateMutation, { data, loading, error }] = useUpdateIssueStateMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      newState: // value for 'newState'
 *   },
 * });
 */
export function useUpdateIssueStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIssueStateMutation,
    UpdateIssueStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateIssueStateMutation,
    UpdateIssueStateMutationVariables
  >(UpdateIssueStateDocument, options);
}
export type UpdateIssueStateMutationHookResult = ReturnType<
  typeof useUpdateIssueStateMutation
>;
export type UpdateIssueStateMutationResult =
  Apollo.MutationResult<UpdateIssueStateMutation>;
export type UpdateIssueStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateIssueStateMutation,
  UpdateIssueStateMutationVariables
>;
